/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect, useState } from "react";
import { DataGrid } from "@mui/x-data-grid";
import { Box, Button, TextField } from "@mui/material";
import { getPasswordRecoveries, searchWorkers } from "../../../../../api/apiCall";
import { useAuth } from "../../../../../auth/auth";
import { useForm } from "react-hook-form";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faCheck, faX } from "@fortawesome/free-solid-svg-icons";

const PasswordRecovery = () => {
  const { state } = useAuth();
  const [workers, setWorkers] = useState<any>([]);

  const getWorkers = async (data: any) => {
    const response: any = await getPasswordRecoveries(state.user?.token);
    setWorkers(response.data || []);
  };

  const handleClick = (userId: any) => {
    const url = `/pace-team/resourcing/dashboard/profile-data?userId=${userId}`;
    window.open(url, "_blank");
  };

  const handleClickEdit = (userId: any) => {
    const url = `/pace-team/resourcing/dashboard/edit-user?userId=${userId}`;
    window.open(url, "_blank");
  };

  const columns: any = [
    {
      field: "fullName",
      headerName: "Full Name",
      flex: 1.3,
      renderCell: (params: any) => (
        <div
          onClick={() => handleClick(params.row.userId)}
          style={{ cursor: "pointer" }}
        >
          {params.row.fullName}
        </div>
      ),
    },
    {
      field: "username",
      headerName: "Username",
      flex: 1,
      headerAlign: "center",
      align: "center",
    },
    {
      field: "pts",
      headerName: "PTS",
      flex: 1,
      headerAlign: "center",
      align: "center",
    },
    {
      field: "email",
      headerName: "Email",
      flex: 1.3,
    },
    {
      field: "recovered",
      headerName: "Recovered",
      flex: 1,
      headerAlign: "center",
      align: "center",
      renderCell: (params: any) => (
        <div>
          {params.row.recovered ? (
            <FontAwesomeIcon icon={faCheck} size={"lg"} color={"green"} />
          ) : (
            <FontAwesomeIcon icon={faX} size={"lg"} color={"red"} />
          )}
        </div>
      ),
    },
    {
      field: "details",
      headerName: "Details",
      flex: 1,
      align: "center",
      headerAlign: "center",
      renderCell: (params: any) => (
        <Button
          variant="contained"
          onClick={() => handleClick(params.row.userId)}
          style={{
            boxShadow: "none",
            backgroundColor: "#6c757d",
          }}
        >
          Details
        </Button>
      ),
    },
  ];

  useEffect(() => {
    getWorkers({});
  }, []);

  return (
    <>
      <div className="form-content">
      </div>
      <Box sx={{ height: "730px", width: "90%", margin: "0 auto" }}>
        <DataGrid
          rows={workers}
          columns={columns}
          disableRowSelectionOnClick
          initialState={{
            pagination: {
              paginationModel: {
                pageSize: 100,
              },
            },
          }}
          pageSizeOptions={[100]}
          sx={{
            "& .MuiDataGrid-columnHeaderTitle": {
              fontWeight: "bold",
              fontSize: 15,
            },
            "& .MuiDataGrid-columnHeader": {
              backgroundColor: "#f0f0f0",
              color: "#000",
              fontWeight: "bold",
            },
            "& .disable-columns": {
              borderRight: "1px solid #bfbfbf",
            },
            "& .border-left": {
              borderLeft: "1px solid #bfbfbf",
            },
          }}
        />
      </Box>
    </>
  );
};

export default PasswordRecovery;
